import { StyleSheet } from 'react-native'
import { fontFamily } from '../../../theme'

export const styles = StyleSheet.create({
  bubbleChatContainer: {
    paddingVertical: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#F6F2E926',
    borderRadius: 28,
    maxWidth: 280
  },
  chatText: {
    fontSize: 14,
    fontFamily: fontFamily.GTAmericaStandardRegular,
    color: 'white',
    paddingLeft: 44,
    paddingRight: 36
  }
})
